import * as i0 from '@angular/core';
import { Pipe, Directive, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from 'angular-i18next';
import { I18NextModule } from 'angular-i18next';
class TranslationPipe {
  constructor(i18nextPipe) {
    this.i18nextPipe = i18nextPipe;
  }
  transform(key, options) {
    return this.i18nextPipe.transform(key, options);
  }
  transformErrorObject(errorObject, prefix = '') {
    const errorKey = `${prefix}.errors.${errorObject.code}.message`;
    let translateResults = this.transform(errorKey);
    if (translateResults.includes(errorObject.code)) {
      translateResults = this.transform('cxone-components.errors.general');
    }
    return translateResults;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TranslationPipe_Factory(t) {
      return new (t || TranslationPipe)(i0.ɵɵdirectiveInject(i1.I18NextPipe, 16));
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "translate",
      type: TranslationPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationPipe, [{
    type: Pipe,
    args: [{
      name: 'translate'
    }]
  }], () => [{
    type: i1.I18NextPipe
  }], null);
})();
class TranslateDirective {
  constructor(element, translationPipe) {
    this.element = element;
    this.translationPipe = translationPipe;
    if (this.translate) {
      this.translateString();
    }
  }
  ngOnChanges() {
    this.translateString();
  }
  translateString() {
    this.element.nativeElement.innerText = this.translationPipe.transform(this.translate);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TranslateDirective_Factory(t) {
      return new (t || TranslateDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TranslationPipe));
    };
  }
  /** @nocollapse */
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TranslateDirective,
      selectors: [["", "translate", ""]],
      inputs: {
        translate: "translate"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateDirective, [{
    type: Directive,
    args: [{
      // tslint:disable-next-line: directive-selector
      selector: '[translate]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: TranslationPipe
  }], {
    translate: [{
      type: Input
    }]
  });
})();
class TranslationModule {
  /** @nocollapse */static {
    this.ɵfac = function TranslationModule_Factory(t) {
      return new (t || TranslationModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TranslationModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [TranslationPipe],
      imports: [CommonModule, I18NextModule.forRoot()]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationModule, [{
    type: NgModule,
    args: [{
      declarations: [TranslationPipe, TranslateDirective],
      providers: [TranslationPipe],
      imports: [CommonModule, I18NextModule.forRoot()],
      exports: [TranslationPipe, TranslateDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TranslateDirective, TranslationModule, TranslationPipe };
